module.exports = __webpack_public_path__ + "static/boxhero_mobile-c6cf2665e3257892b4cdabd9b4ed5b01.png";